'use client';

import { c as _c } from "react/compiler-runtime";
import { useSessionList } from '@clerk/nextjs';
import { Avatar, AvatarFallback, AvatarImage } from '@extern/ui/avatar';
import { Button } from '@extern/ui/button';
import { useRouter, useSearchParams } from 'next/navigation';
import { useAuthEvents } from '@/app/(auth)/_hooks/use-auth-events';
import { AuthCard } from '@/app/(auth)/_partials/auth-card';
import { useSignInFlowStore } from '@/app/(auth)/sign-in/_hooks/use-sign-in-flow-store';
import { useUtmParams } from '@/hooks/use-utm-params';
import { DEFAULT_LOGGED_PAGE } from '@/infra/constants/routes';
import { getAllowlistedSearchParams } from '@/utils/get-allowlisted-search-params';
import { getNameInitials } from '@/utils/get-name-initials';
export function SignInChooseSession() {
  const $ = _c(17);
  const router = useRouter();
  const {
    setActive,
    sessions,
    isLoaded
  } = useSessionList();
  const {
    trackSignInSessionSelected
  } = useAuthEvents();
  useUtmParams();
  const searchParams = useSearchParams();
  if (!isLoaded) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AuthCard.Header><AuthCard.Title>Active sessions</AuthCard.Title></AuthCard.Header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== router || $[2] !== sessions || $[3] !== setActive || $[4] !== trackSignInSessionSelected) {
    let t2;
    if ($[6] !== router || $[7] !== setActive || $[8] !== trackSignInSessionSelected) {
      t2 = session => <div className="flex items-center justify-between gap-4" key={session.id}><Avatar className="h-10 w-10 bg-transparent"><AvatarImage src={session?.publicUserData?.imageUrl} /><AvatarFallback className="text-center font-bold text-3xl">{getNameInitials(`${session?.publicUserData?.firstName} ${session?.publicUserData?.lastName}`)}</AvatarFallback></Avatar><div className="flex flex-1 flex-col gap-1 text-left"><p className="font-medium text-sm leading-none">{`${session?.publicUserData?.firstName} ${session?.publicUserData?.lastName}`}</p><p className="text-muted-foreground text-sm">{session?.publicUserData.identifier}</p></div><Button onClick={async () => {
          if (session?.id && setActive) {
            trackSignInSessionSelected("existing_session", {
              method: "google"
            });
            useSignInFlowStore.getState().onChange({
              step: "start"
            });
            await setActive({
              session: session.id,
              redirectUrl: DEFAULT_LOGGED_PAGE
            });
            router.push(DEFAULT_LOGGED_PAGE);
          }
        }}>Access</Button></div>;
      $[6] = router;
      $[7] = setActive;
      $[8] = trackSignInSessionSelected;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = sessions.map(t2);
    $[1] = router;
    $[2] = sessions;
    $[3] = setActive;
    $[4] = trackSignInSessionSelected;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[10] !== searchParams || $[11] !== sessions.length || $[12] !== trackSignInSessionSelected) {
    t2 = sessions.length === 0 && <div className="flex flex-col gap-4 text-center"><p className="text-muted-foreground text-sm">No active sessions</p><Button asChild={true}><a href={`/sign-in?${getAllowlistedSearchParams(searchParams)}`} onClick={() => {
          trackSignInSessionSelected("fallback");
        }}>Sign in using a different account</a></Button></div>;
    $[10] = searchParams;
    $[11] = sessions.length;
    $[12] = trackSignInSessionSelected;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== t1 || $[15] !== t2) {
    t3 = <AuthCard>{t0}<AuthCard.Content>{t1}{t2}</AuthCard.Content></AuthCard>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}